var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7895 11.7617C18.5424 11.7617 16.5343 12.9264 16.5343 15.0783C16.5343 17.5462 20.0957 17.7166 20.0957 18.9564C20.0957 19.4784 19.4975 19.9457 18.4758 19.9457C17.0257 19.9457 15.9419 19.2927 15.9419 19.2927L15.4782 21.4642C15.4782 21.4642 16.7267 22.0158 18.3843 22.0158C20.841 22.0158 22.7743 20.7939 22.7743 18.6052C22.7743 15.9975 19.198 15.8321 19.198 14.6814C19.198 14.2725 19.689 13.8244 20.7079 13.8244C21.8574 13.8244 22.7953 14.2993 22.7953 14.2993L23.2491 12.202C23.2491 12.202 22.2286 11.7617 20.7895 11.7617ZM0.230681 11.92L0.17627 12.2366C0.17627 12.2366 1.12163 12.4096 1.97308 12.7547C3.06939 13.1505 3.14749 13.3809 3.33212 14.0965L5.3441 21.8525H8.04117L12.1962 11.92H9.50533L6.83546 18.6732L5.746 12.9489C5.64609 12.2937 5.14 11.92 4.52051 11.92H0.230681ZM13.2783 11.92L11.1673 21.8525H13.7333L15.8368 11.92H13.2783ZM27.5896 11.92C26.9709 11.92 26.6431 12.2513 26.4025 12.8302L22.6432 21.8525H25.3341L25.8547 20.3488H29.1329L29.4495 21.8525H31.8238L29.7525 11.92H27.5896ZM27.9396 14.6035L28.7372 18.3306H26.6004L27.9396 14.6035Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/VisaLogo.b59fa25c193e1d21e1d116a2150f78d0.svg";
export { ForwardRef as ReactComponent };